import SignaturePad from 'signature_pad';

/**
 * Open a signature modal. Resolves to a PNG Blob if signed + saved,
 * or null if the user cancelled.
 *
 * @param {object} opts
 * @param {string} opts.title    - modal title (e.g. "Sign for Sipho Ndlovu — Mon 5 May")
 * @returns {Promise<Blob|null>}
 */
export function openSignatureModal({ title }) {
  return new Promise((resolve) => {
    const overlay = document.createElement('div');
    overlay.className = 'sig-modal-overlay';
    overlay.innerHTML = `
      <div class="sig-modal" role="dialog" aria-modal="true">
        <div class="sig-modal-head">
          <div class="sig-modal-title">${title}</div>
        </div>
        <canvas class="sig-canvas" width="640" height="240"></canvas>
        <div class="sig-modal-actions">
          <button type="button" class="btn btn-ghost"  data-action="clear">Clear</button>
          <button type="button" class="btn btn-ghost"  data-action="cancel">Cancel</button>
          <button type="button" class="btn btn-primary" data-action="save">Save signature</button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);

    const canvas = overlay.querySelector('.sig-canvas');
    // Resize for HiDPI before initializing the pad
    const ratio = window.devicePixelRatio || 1;
    const rect  = canvas.getBoundingClientRect();
    canvas.width  = rect.width  * ratio;
    canvas.height = rect.height * ratio;
    canvas.getContext('2d').scale(ratio, ratio);

    const pad = new SignaturePad(canvas, { penColor: '#0D1B35', backgroundColor: '#fff' });

    function close(result) {
      overlay.remove();
      resolve(result);
    }

    overlay.addEventListener('click', (e) => {
      const action = e.target.dataset?.action;
      if (action === 'clear')  pad.clear();
      if (action === 'cancel') close(null);
      if (action === 'save') {
        if (pad.isEmpty()) return;
        canvas.toBlob((blob) => close(blob), 'image/png');
      }
    });

    // Esc to cancel
    const onKey = (e) => {
      if (e.key === 'Escape') { document.removeEventListener('keydown', onKey); close(null); }
    };
    document.addEventListener('keydown', onKey);
  });
}
